// extracted by mini-css-extract-plugin
export default {"container":"Ida-z","heading":"Jda-z","links":"Kda-z","linkBtn":"Lda-z","disabled":"Mda-z","linkUppercaseBold":"Nda-z","copy":"Oda-z","subCopy":"Pda-z"};